import {makeAutoObservable} from "mobx";

import {
    CHAT_ROUTE,
    DIRECT_CHATS_ROUTE,
    REQUEST_CHAT_ROUTE,
    MESSAGE_ROUTE
} from "../utils/consts";

export default class MessagesStore {
    constructor({apartmentChat, directChat, requestChat}) {
        this.apartmentChat = apartmentChat;
        this.directChat = directChat;
        this.requestChat = requestChat;

        makeAutoObservable(this);
    }

    get apartmentUnreadCount() {
        return Number(this.apartmentChat?.totalUnreadCount || 0);
    }

    get directUnreadCount() {
        return Number(this.directChat?.totalUnreadCount || 0);
    }

    get requestUnreadCount() {
        return Number(this.requestChat?.unreadCount || 0);
    }

    get totalUnreadCount() {
        // Глобальный badge "Сообщения" считаем только по реальным перепискам.
        // Общий чат заявок может содержать сотни служебных/рабочих событий
        // и не должен раздувать счётчик сообщений в нижнем меню и PWA badge.
        return (
            this.apartmentUnreadCount +
            this.directUnreadCount
        );
    }

    get hasUnread() {
        return this.totalUnreadCount > 0;
    }

    get targetRoute() {
        return MESSAGE_ROUTE;
    }

    get hubCardsData() {
        return [
            {
                key: "add-chats",
                emoji: "💬",
                title: "Чаты по объявлениям",
                description: "Переписки гостей и владельцев по конкретным квартирам.",
                route: CHAT_ROUTE,
                unread: this.apartmentUnreadCount,
                authRequired: false,
                buttonText: "Открыть чаты"
            },
            {
                key: "direct",
                emoji: "👤",
                title: "Личные чаты",
                description: "Переписки напрямую между пользователями Arento.",
                route: DIRECT_CHATS_ROUTE,
                unread: this.directUnreadCount,
                authRequired: true,
                buttonText: "Открыть личные"
            },
            {
                key: "requests",
                emoji: "🏠",
                title: "Чат заявок",
                description: "Общий рабочий чат по заявкам гостей.",
                adminDescription: "Публикация заявок, предложения квартир и сбор подборок.",
                route: REQUEST_CHAT_ROUTE,
                unread: this.requestUnreadCount,
                authRequired: true,
                buttonText: "Открыть заявки"
            }
        ];
    }

    clearAllRuntimeState() {
        this.apartmentChat?.clearStore?.();
        this.directChat?.clearStore?.();
        this.requestChat?.clearStore?.();
    }
}